<template>
  <v-bottom-navigation
    v-model="activeTab"
    grow
    color="teal-darken-2"
    elevation="4"
    class="footer-nav"
    @update:model-value="onTabChange"
  >
    <v-btn value="home">
      <v-icon>mdi-home-account</v-icon>
      <span>工作台</span>
    </v-btn>

    <v-btn value="overview">
      <v-icon>mdi-account-clock</v-icon>
      <span>打卡</span>
    </v-btn>

    <v-btn value="calender">
      <v-icon>mdi-calendar-month</v-icon>
      <span>统计</span>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
export default {
  name: "Footerbar",
  data() {
    return {
      activeTab: "overview",
    };
  },
  mounted() {
    this.syncRoute();
  },
  watch: {
    $route() {
      this.syncRoute();
    },
  },
  methods: {
    syncRoute() {
      const name = this.$route.name;
      if (name === "home" || name === "overview" || name === "calender") {
        this.activeTab = name;
      }
    },
    onTabChange(tab) {
      if (this.$route.name !== tab) {
        this.$router.push({ name: tab });
      }
    },
  },
};
</script>

<style scoped>
.footer-nav {
  position: fixed !important;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding-bottom: env(safe-area-inset-bottom, 0px);
}
</style>
